// components/DataTable/DataTableActions.jsx

import React from "react";

import {
  Button,
  OverlayTrigger,
  Tooltip,
  Popover
} from "react-bootstrap";

import DataTableEditForm from "./DataTableEditForm";

/**
 * @typedef {Object} DataTableAction
 * @property {string} title
 * @property {React.ReactNode} [icon]
 * @property {"edit"} [type]
 * @property {function(Object): void|Promise<void>} [onClick]
 * @property {function(Object): boolean} [visible]
 */

/**
 * @param {Object} props
 */
function DataTableActions({
  row,
  actions,
  onEdit,
  editable,
  disabled,

  /*
   * Popover
   */
  editMode,
  isEditing,
  editingRow,
  columns,
  errors,
  onChange,
  onSave,
  onCancel,
  saving
}) {
  if (!Array.isArray(actions)) {
    return null;
  }

  return (
    <div className="datatable-actions">
      {actions.map(
        (action, index) => {
          if (
            action.type === "edit" &&
            !editable
          ) {
            return null;
          }

          if (
            typeof action.visible ===
              "function" &&
            !action.visible(row)
          ) {
            return null;
          }

          /*
           * --------------------------------
           * EDIT ACTION + POPOVER
           * --------------------------------
           */

          if (
            action.type === "edit" &&
            editMode ===
              "popover"
          ) {
            const editButton = (
              <Button
                variant="light"
                size="sm"
                className="datatable-action-button"
                disabled={disabled}
                aria-label={
                  action.title
                }
                onClick={() =>
                  onEdit(row)
                }
              >
                {action.icon}
              </Button>
            );

            const popover = (
              <Popover
                id={`datatable-popover-${index}`}
                className="datatable-popover"
              >
                <Popover.Title as="h3">
                  ویرایش اطلاعات
                </Popover.Title>

                <Popover.Content>
                  {editingRow && (
                    <DataTableEditForm
                      row={
                        editingRow
                      }
                      columns={
                        columns
                      }
                      errors={
                        errors
                      }
                      onChange={
                        onChange
                      }
                      onSave={
                        onSave
                      }
                      onCancel={
                        onCancel
                      }
                      saving={
                        saving
                      }
                      showButtons={
                        true
                      }
                    />
                  )}
                </Popover.Content>
              </Popover>
            );

            return (
              <OverlayTrigger
                key={
                  `${action.title}-${index}`
                }
                trigger="click"
                placement="left"
                overlay={popover}
                show={isEditing}
                rootClose={false}
              >
                {editButton}
              </OverlayTrigger>
            );
          }

          /*
           * --------------------------------
           * NORMAL ACTION
           * --------------------------------
           */

          return (
            <OverlayTrigger
              key={
                `${action.title}-${index}`
              }
              placement="top"
              overlay={
                <Tooltip>
                  {action.title}
                </Tooltip>
              }
            >
              <button
                // variant="outline-primary"
                size="sm"
                className="datatable-action-button tooltipBtn"
                data-tooltip={action.title}
                disabled={
                  disabled
                }
                aria-label={
                  action.title
                }
                onClick={async () => {
                  if (
                    action.type ===
                    "edit"
                  ) {
                    onEdit(row);
                    return;
                  }

                  if (
                    typeof action.onClick ===
                    "function"
                  ) {
                    await action.onClick(
                      row
                    );
                  }
                }}
              >
                {action.icon}
              </button>
            </OverlayTrigger>
          );
        }
      )}
    </div>
  );
}

export default React.memo(
  DataTableActions
);